<script setup lang="ts">
    import { ChevronRight, LoaderCircle } from 'lucide-vue-next';
    import Button from '@/components/ui/button/Button.vue';
    import { ref, watch } from 'vue';

    const props = defineProps<{
        isFetching: boolean;
    }>();

    const isLoading = ref(false);

    watch(
        () => props.isFetching,
        (newVal, oldVal) => {
            if (oldVal === true && newVal === false) {
                isLoading.value = false;
            }
        },
    );

    const emit = defineEmits<{
        (e: 'refetch'): void;
    }>();

    const handleRefetch = () => {
        isLoading.value = true;
        emit('refetch');
    };
</script>

<template>
    <Button
        variant="ghost_primary"
        width="narrow"
        class="self-start"
        size="xs"
        @click="handleRefetch"
        :disabled="isFetching"
    >
        {{ $t('activities.search') }}
        <ChevronRight
            v-if="!isLoading"
            class="text-primary"
        />
        <LoaderCircle
            v-else
            class="text-primary animate-spin"
        />
    </Button>
</template>
